<template>

	<div class="features">

		<a class="feature" :href="url" target="_blank" v-if="showIt('url') && !!url">
			<font-awesome-icon icon="link" class="svg desktop" :style="{ color: 'white' }" />
			<span class="name" v-html="url.replace('https://','')" />
		</a>

		<span class="feature" v-if="showIt('device') && device==='desktop'">
			<font-awesome-icon icon="desktop" class="svg desktop" :style="{ color: 'white' }" />
			<span class="name">Desktop</span>
		</span> 

		<span class="feature" v-if="showIt('device') && device==='mobile'">
			<font-awesome-icon icon="mobile-alt" class="svg mobile" :style="{ color: 'white' }" />
			<span class="name">Mobile</span>
		</span>

		<a href="" class="feature" v-if="showIt('searchType') && ( project.has || project.hasRankTracking ) &&  project.searchType.toLowerCase()==='local'">
			<font-awesome-icon icon="search" class="svg mobile" :style="{ color: 'white' }" />
			<span class="name">Local</span>
		</a>

		<span class="feature" v-if="showIt('searchType') && ( project.has || project.hasRankTracking ) && project.searchType.toLowerCase()==='organic'">
			<font-awesome-icon icon="search" class="svg mobile" :style="{ color: 'white' }" />
			<span class="name">Organic</span>
		</span>

		<span class="feature" v-if="showIt('locationName') && !mapLink && !!project.locationName">
			<font-awesome-icon icon="globe-americas" class="svg" :style="{ color: 'white' }" />
			<span class="name" v-html="project.locationName" />
		</span>

		<a :href="mapLink" class="feature" v-if="showIt('locationName') && mapLink && !!project.locationName" target="_blank">
			<font-awesome-icon icon="globe-americas" class="svg" :style="{ color: 'white' }" />
			<span class="name" v-html="project.locationName" />
		</a>

		<span class="feature" v-if="showIt('extension') && typeof project.extension !== 'undefined' && project.extension !== ''">
			<font-awesome-icon icon="keyboard" class="svg" :style="{ color: 'white' }" />
			<span class="name" v-html="'google.'+project.extension" />
		</span>

		<span class="feature red" v-if="showIt('paused') && !project.active">
			<font-awesome-icon icon="circle-pause" class="svg" :style="{ color: 'white' }" />
			<span class="name" v-html="'Paused'" />
		</span>

	</div>
	

</template>

<script>
export default {
	name: 'ProjectFeatures',
	props: {
		project: {
			type: Object,
			default: () => {}
		},
		ignore: {
			type: Array,
			default: () => []
		},
		show: {
			type: Array,
			default: () => []
		}
	},
	data() {

		return {
			
		}

	},
	methods: {

		showIt ( type ) {

			if ( this.show.length > 0 && this.show.indexOf(type) === -1 ) return false;

			return this.ignore.indexOf(type) === -1;

		}

	},
	computed: {

		url () {

			if ( !this.project.url ) return null;

			if ( typeof this.project.url === 'object' ) {

				return this.project.url.label;

			}

			return this.project.url;
			
		},
		device () {

			if ( !this.project.device ) return null;

			if ( typeof this.project.device === 'object' ) {

				return this.project.device.device;

			}

			return this.project.device;
			
		},
		mapLink () {

			if ( this.project.locationCoordinate && this.project.locationCoordinate.coordinates && this.project.locationCoordinate.coordinates.length > 0 ) {

				return 'https://www.google.com/maps/@' + this.project.locationCoordinate.coordinates[1] + ',' + this.project.locationCoordinate.coordinates[0] + ',' + this.project.locationZoom + 'z';

			}

			return null;

		}

	}
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';
.features {
	display: block;
	margin-top: 10px;
	.feature {

		display: inline-block;
		vertical-align: top;
		background-color: @darkContrast;
		padding: 3px 8px;
		border-radius: 10px;
		font-size: 12px;
		color: #fff;
		text-decoration: none;
		margin: 0 4px 4px 0;

		.svg {
			margin-right: 4px;
		}

		.name {

			color: #fff;

		}

		&.red {

			background-color: @red;

		}

	}
	a.feature {

		&:hover {

			text-decoration: underline;

		}

	}

}
@media screen and (min-width: 768px) {
	.features {

		display: inline-block;
		vertical-align: top;
		margin-top: 5px;

	}
}
</style>